import { render, staticRenderFns } from "./DuplicateExportFieldsModal.vue?vue&type=template&id=62b0a64c"
import script from "./DuplicateExportFieldsModal.vue?vue&type=script&lang=js"
export * from "./DuplicateExportFieldsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports